import { createSelector } from '@reduxjs/toolkit';
import { ActionStatus } from 'store/ActionState';
import { RootState } from 'store/RootReducer';
import { AccessTypeOption } from 'components/app/store/requestAccess/RequestAccessSlice';
import IAccessTypes from 'common/IAccessTypes';
import { RequestAccessState } from './RequestAccessSlice';

const selectSelf = (state: RootState): RequestAccessState => {
  return state.requestAccess;
};

const selectAccessTypeOptions = createSelector(
  selectSelf,
  (state: RequestAccessState): { [key in IAccessTypes]?: AccessTypeOption } | undefined => state.accessTypeOptions
);

const selectRequestAccessProcessing = createSelector(
  selectSelf,
  (state: RequestAccessState): boolean => state.requestAccessState?.status === ActionStatus.PROCESSING
);

const RequestAccessSelectors = {
  selectRequestAccessProcessing,
  selectAccessTypeOptions,
};

export default RequestAccessSelectors;
